import { getLocalTimeZone, today } from "@internationalized/date";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TransactionRecipient,
  TransferFormData,
} from "../../pages/TransactionPage/types";

const currentDate = today(getLocalTimeZone()).toString();

interface InitialState {
  openModal: boolean;
  isRecipientModalOpen: boolean;
  action: "FORM" | "CONFIRMATION" | "SUCCESS";
  origin: "ACCOUNT_SHEDULED" | "NEW_TRANSACTION";
  formData: TransferFormData;
}

const initialState: InitialState = {
  openModal: false,
  isRecipientModalOpen: false,
  action: "FORM",
  origin: "NEW_TRANSACTION",
  formData: {
    bankAccountIdentification: "",
    amount: "",
    currency: "1",
    date: currentDate,
    description: "",
    cuit: "",
    accountType: "",
    nickName: "",
    sheduledAccount: false,
    recipient: undefined,

    //ccl
    isCCL: false,
    isSingleBank: true,
    singleBank: "",
    singleBankNumber: "",
    singleBankSwift: "",
    singleBankABA: "",
    singleBankReference: "",
    intermediaryBank: "",
    intermediaryBankSwift: "",
    intermediaryBankABA: "",
    intermediaryBankReference: "",
  },
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },
    updateAction: (state, action) => {
      state.action = action.payload;
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
      state.action = "FORM";
      state.origin = "NEW_TRANSACTION";
    },

    openModal: (
      state,
      action: PayloadAction<
        | TransactionRecipient
        | { recipient?: TransactionRecipient; currency?: string }
        | undefined
      >
    ) => {
      const payload =
        typeof action.payload === "object"
          ? action.payload
          : { recipient: action.payload };

      return {
        ...state,
        openModal: true,
        formData: {
          ...state.formData,
          recipient: payload?.recipient,
          ...(payload?.currency && { currency: payload.currency }),
        },
        // Close recipient modal if was open and recipient was passed
        isRecipientModalOpen: state.isRecipientModalOpen && !payload?.recipient,
      };
    },
    openModalSheduledOrigin: (state, action) => {
      state.openModal = true;
      state.origin = "ACCOUNT_SHEDULED";

      if (action.payload.formData) {
        state.formData = {
          ...state.formData,
          ...action.payload.formData,
        };
      }
    },
    closeModal: (state) => {
      state.openModal = false;
      state.formData = initialState.formData;
      state.action = "FORM";
      state.origin = "NEW_TRANSACTION";
    },
    openRecipientModal: (state) => {
      state.isRecipientModalOpen = true;
    },
    closeRecipientModal: (state) => {
      state.isRecipientModalOpen = false;
    },
    updateRecipient: (
      state,
      action: PayloadAction<Partial<TransactionRecipient>>
    ) => {
      return {
        ...state,
        formData: { ...state.formData, recipient: action.payload },
      };
    },
  },
});

export const {
  updateFormData,
  resetForm,
  openModal,
  openModalSheduledOrigin,
  closeModal,
  updateAction,
  openRecipientModal,
  closeRecipientModal,
  updateRecipient,
} = transactionSlice.actions;

export default transactionSlice.reducer;
